











import Vue from 'vue'
import FilterDropdown from '@/pages/common/filter-dropdown/FilterDropdown.vue'
import { DropdownItem } from '@/pages/common/types'
import {
  loadStatuses,
  statusesDropdownModel,
  $statuses,
  selectStatus,
} from '@/pages/users/students/list/parts/statuses-dropdown/statuses-dropdown.model'

export default Vue.extend({
  components: {
    FilterDropdown,
  },
  effector: {
    ...statusesDropdownModel.store,
    $statuses,
  },
  props: {
    label: String,
  },
  data() {
    return {
      statusesDropdownMethods: statusesDropdownModel.methods,
    }
  },
  methods: {
    ...statusesDropdownModel.methods,
    onSelectItem(item: DropdownItem | null) {
      if (item !== null) {
        selectStatus(item)
        this.$emit('setItem', item.name)
      }
    },
  },
  mounted() {
    loadStatuses()
  },
})
